import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const DownloadReceiptIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M23.5 30.25H5C3.20508 30.25 1.75 28.7949 1.75 27V3.75C1.75 2.64543 2.64543 1.75 3.75 1.75H18.75C19.8546 1.75 20.75 2.64543 20.75 3.75V17.6087C18.5347 18.6445 17 20.893 17 23.5C17 26.8207 19.4901 29.5598 22.705 29.9519L23.5 30.25Z"
          fill="white"
        />
        <path
          d="M11.25 4.5C11.8023 4.5 12.25 4.94772 12.25 5.5V5.92113C12.3852 5.94527 12.5179 5.974 12.6473 6.00711C13.2738 6.16738 13.9432 6.46192 14.3978 6.95795C14.7709 7.36512 14.7433 7.99769 14.3362 8.37082C13.929 8.74396 13.2964 8.71636 12.9233 8.30919C12.8389 8.21711 12.5938 8.05783 12.1516 7.94471C11.7331 7.83763 11.2446 7.80044 10.7909 7.85287C10.328 7.90637 9.98239 8.04286 9.77547 8.20668C9.60368 8.34269 9.5 8.51195 9.5 8.80371C9.5 8.98614 9.54141 9.04967 9.55417 9.06781C9.57226 9.09353 9.62162 9.14806 9.76551 9.21202C10.1046 9.36274 10.6128 9.42542 11.352 9.50124L11.4302 9.50922C12.0576 9.57315 12.8826 9.65722 13.5468 9.9524C13.9185 10.1176 14.2988 10.3716 14.5815 10.7733C14.8695 11.1827 15 11.6656 15 12.1883C15 13.1373 14.5789 13.8808 13.9364 14.3765C13.4387 14.7605 12.8386 14.9758 12.25 15.0804V15.5C12.25 16.0523 11.8023 16.5 11.25 16.5C10.6977 16.5 10.25 16.0523 10.25 15.5V15.0709C10.0812 15.0407 9.91601 15.0034 9.75623 14.9592C9.13001 14.7862 8.448 14.4692 8.0111 13.9282C7.66414 13.4985 7.7312 12.8689 8.1609 12.5219C8.59059 12.175 9.22019 12.242 9.56715 12.6717C9.62715 12.746 9.84494 12.9088 10.2889 13.0315C10.7046 13.1464 11.2001 13.1916 11.6653 13.1439C12.1399 13.0953 12.4988 12.9596 12.7147 12.793C12.894 12.6548 13 12.4834 13 12.1883C13 12.0059 12.9586 11.9424 12.9458 11.9242C12.9277 11.8985 12.8784 11.844 12.7345 11.78C12.3954 11.6293 11.8872 11.5666 11.148 11.4908L11.0698 11.4828C10.4424 11.4189 9.61738 11.3348 8.95324 11.0396C8.58151 10.8744 8.20118 10.6205 7.91848 10.2187C7.63047 9.80935 7.5 9.32641 7.5 8.80371C7.5 7.87138 7.90666 7.1353 8.53404 6.6386C9.03834 6.23936 9.65146 6.01797 10.25 5.9116V5.5C10.25 4.94772 10.6977 4.5 11.25 4.5Z"
          fill="#006DFF"
        />
        <path
          d="M22.6129 29.94C20.2966 29.6239 18.3687 28.0875 17.4982 26L1.75 26V27C1.75 28.7949 3.20507 30.25 5 30.25H24C23.5038 30.25 23.0336 30.1388 22.6129 29.94Z"
          fill="#E4E0FF"
        />
        <path
          d="M22.125 12.25L20.75 11.75V17.6087C21.5852 17.2182 22.5171 17 23.5 17C24.4829 17 25.4148 17.2182 26.25 17.6087V11.75L24.875 12.25L23.5 11.75L22.125 12.25Z"
          fill="#C0AAFE"
        />
        <path
          d="M21.5 11.2247V3.75C21.5 2.23122 20.2688 1 18.75 1H3.75C2.23122 1 1 2.23122 1 3.75V27C1 29.2091 2.79086 31 5 31L23.5 31C24.7948 31 25.9254 30.2969 26.5308 29.2516C25.6259 29.7295 24.5945 30 23.5 30C22.4055 30 21.3741 29.7295 20.4692 29.2516C20.5185 29.3367 20.5713 29.4196 20.6273 29.5H5C3.61929 29.5 2.5 28.3807 2.5 27V3.75C2.5 3.05964 3.05964 2.5 3.75 2.5H18.75C19.4404 2.5 20 3.05964 20 3.75V18.0218C20.4632 17.7253 20.9665 17.4858 21.5 17.3135V12.8208L21.8687 12.9548C22.0343 13.0151 22.2157 13.0151 22.3813 12.9548L23.5 12.5481L24.6187 12.9548C24.7843 13.0151 24.9657 13.0151 25.1313 12.9548L25.5 12.8208V17.3135C26.0335 17.4858 26.5368 17.7253 27 18.0218V11.75C27 11.5053 26.8807 11.2761 26.6803 11.1357C26.4799 10.9953 26.2236 10.9615 25.9937 11.0452L24.875 11.452L23.7563 11.0452C23.5907 10.985 23.4093 10.985 23.2437 11.0452L22.125 11.452L21.5 11.2247Z"
          fill="#0F3893"
        />
        <path
          d="M17.1694 22.0192C17.115 22.0066 17.0583 22 17 22H14.75C14.3358 22 14 22.3358 14 22.75C14 23.1642 14.3358 23.5 14.75 23.5H17C17 22.9906 17.0586 22.4949 17.1694 22.0192Z"
          fill="#0F3893"
        />
        <path
          d="M17.2504 25.2928C17.1721 25.2651 17.0878 25.25 17 25.25H14.75C14.3358 25.25 14 25.5858 14 26C14 26.4142 14.3358 26.75 14.75 26.75H17C17.285 26.75 17.5329 26.591 17.6598 26.3568C17.4936 26.0177 17.3561 25.662 17.2504 25.2928Z"
          fill="#0F3893"
        />
        <path
          d="M14 19.5C14 19.0858 14.3358 18.75 14.75 18.75H17C17.4142 18.75 17.75 19.0858 17.75 19.5C17.75 19.9142 17.4142 20.25 17 20.25H14.75C14.3358 20.25 14 19.9142 14 19.5Z"
          fill="#0F3893"
        />
        <path
          d="M4.75 22.75C4.75 22.3358 5.08579 22 5.5 22H8.75C9.16421 22 9.5 22.3358 9.5 22.75C9.5 23.1642 9.16421 23.5 8.75 23.5H5.5C5.08579 23.5 4.75 23.1642 4.75 22.75Z"
          fill="#0F3893"
        />
        <path
          d="M4.75 19.5C4.75 19.0858 5.08579 18.75 5.5 18.75H11C11.4142 18.75 11.75 19.0858 11.75 19.5C11.75 19.9142 11.4142 20.25 11 20.25H5.5C5.08579 20.25 4.75 19.9142 4.75 19.5Z"
          fill="#0F3893"
        />
        <path
          d="M4.75 26C4.75 25.5858 5.08579 25.25 5.5 25.25H11C11.4142 25.25 11.75 25.5858 11.75 26C11.75 26.4142 11.4142 26.75 11 26.75H5.5C5.08579 26.75 4.75 26.4142 4.75 26Z"
          fill="#0F3893"
        />
        <path
          d="M31 23.5C31 27.6421 27.6421 31 23.5 31C19.3579 31 16 27.6421 16 23.5C16 19.3579 19.3579 16 23.5 16C27.6421 16 31 19.3579 31 23.5Z"
          fill="#006DFF"
        />
        <path
          d="M24.125 20C24.125 19.6548 23.8452 19.375 23.5 19.375C23.1548 19.375 22.875 19.6548 22.875 20V25.4911L21.4419 24.0581C21.1979 23.814 20.8021 23.814 20.5581 24.0581C20.314 24.3021 20.314 24.6979 20.5581 24.9419L23.056 27.4399C23.0628 27.4468 23.0698 27.4535 23.0769 27.4601C23.1304 27.5092 23.1903 27.5474 23.2537 27.5746C23.3293 27.607 23.4126 27.625 23.5 27.625C23.5832 27.625 23.6626 27.6087 23.7352 27.5792C23.8104 27.5487 23.8809 27.503 23.942 27.4419L26.4419 24.9419C26.686 24.6979 26.686 24.3021 26.4419 24.0581C26.1979 23.814 25.8021 23.814 25.5581 24.0581L24.125 25.4911V20Z"
          fill="white"
        />
      </svg>
    );
  }
);

export default DownloadReceiptIcon;
